import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Assets/Css/home.css";
import { FaWhatsapp } from "react-icons/fa";
import { FiChevronUp } from "react-icons/fi";
import WebHeader from "./Components/WebHeader";
import WebFooter from "./Components/WebFooter";
import HomePage from "./Webpages/HomePage";
import Contact from "./Webpages/Contact";
import OurProducts from "./Webpages/OurProducts";
import About from "../src/Webpages/About";
import ResistanceWeldedFlexibles from "./Webpages/resistanceWeldedFlexibles";
import CopperLaminatedFlexibles from "./Webpages/copperLaminatedFlexibles";
import CopperLaminationFullTinned from "./Webpages/copperLaminationFullTinned";
import AluminumLaminatedFlexibles from "./Webpages/aluminumLaminatedFlexibles";
import FabricatedCopperBusbars from "./Webpages/fabricatedCopperBusbars";
import FabricatedAluminumBusbars from "./Webpages/fabricatedAluminumBusbars";
import NonFerrousMachinedParts from "./Webpages/nonFerrousMachinedParts";
import Bimetallicproductsandwashers from "./Webpages/bimetallicproductsandwashers";
import SubAssembliesSwitchgear from "./Webpages/subAssembliesSwitchgear";
import SubAssembliesBusbartrunking from "./Webpages/subAssembliesBusbartrunking";
import BusbartrunkingPlugInAssemblies from "./Webpages/busbartrunkingPlugInAssemblies";
import FishPlatesforBusbartrunking from "./Webpages/fishPlatesforBusbartrunking";
import StampedPartsNonFerrous from "./Webpages/stampedPartsNonFerrous";
import SilverBrazing from "./Webpages/silverBrazing";
import TinSilverPlatedCopperBars from "./Webpages/tinSilverPlatedCopperBars";
import FeederLengthForBTS from "./Webpages/feederLengthForBTS";
import PressTools from "./Webpages/pressTools";
import FacilitiesPage from "./Webpages/Facilities";
import ScrollToTop from "./Webpages/ScrollToTop";
import ProductsData from "./Webpages/ProductsData";

const ScrollToTopButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  useEffect(() => {
    const toggleVisible = () => {
      setVisible(window.scrollY > 300);
    };
    window.addEventListener("scroll", toggleVisible);
    return () => window.removeEventListener("scroll", toggleVisible);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div
      className="scroll-to-top-custom"
      onClick={scrollToTop}
      style={{ display: visible ? "flex" : "none" }}
    >
      <FiChevronUp size={28} color="#00aaff" />
    </div>
  );
};

const App = () => {
  return (
    <BrowserRouter>
      <WebHeader />
      <div>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/data" element={<ProductsData />} />
          <Route path="/ourproducts" element={<OurProducts />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="/facilities" element={<FacilitiesPage />} />
          <Route
            path="/resistance-welded-flexibles"
            element={<ResistanceWeldedFlexibles />}
          />
          <Route
            path="/copper-laminated-flexibles"
            element={<CopperLaminatedFlexibles />}
          />
          <Route
            path="/copper-lamination-full-tinned"
            element={<CopperLaminationFullTinned />}
          />
          <Route
            path="/aluminum-laminated-flexibles"
            element={<AluminumLaminatedFlexibles />}
          />
          <Route
            path="/fabricated-copper-busbars"
            element={<FabricatedCopperBusbars />}
          />
          <Route
            path="/fabricated-aluminum-busbars"
            element={<FabricatedAluminumBusbars />}
          />
          <Route
            path="/non-ferrous-machined-parts"
            element={<NonFerrousMachinedParts />}
          />
          <Route
            path="/bimetallic-products-and-washers"
            element={<Bimetallicproductsandwashers />}
          />
          <Route
            path="/sub-assemblies-switchgear"
            element={<SubAssembliesSwitchgear />}
          />
          <Route
            path="/sub-assemblies-busbar-trunking"
            element={<SubAssembliesBusbartrunking />}
          />
          <Route
            path="/busbar-trunking-plug-in-assemblies"
            element={<BusbartrunkingPlugInAssemblies />}
          />
          <Route
            path="/fish-plates-for-busbar-trunking"
            element={<FishPlatesforBusbartrunking />}
          />
          <Route
            path="/stamped-parts-non-ferrous"
            element={<StampedPartsNonFerrous />}
          />
          <Route path="/silver-brazing" element={<SilverBrazing />} />
          <Route
            path="/tin-silver-plated-copper-bars"
            element={<TinSilverPlatedCopperBars />}
          />
          <Route
            path="/feeder-length-for-bts"
            element={<FeederLengthForBTS />}
          />
          <Route path="/press-tools" element={<PressTools />} />
        </Routes>
        <a
        
           href="https://wa.me/9021399351"
          className="whatsapp-icon"
          target="_blank"
          rel="noopener noreferrer"
          title="Chat with us!"
        >
          <FaWhatsapp />
        </a>
      </div>
      <ScrollToTopButton />
      <ScrollToTop />

      <WebFooter />
    </BrowserRouter>
  );
};

export default App;
